import { Tooltip } from "@admin/components/atoms/Tooltip";

interface RadixAvailibilityTooltipProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  trigger: React.ReactNode;
}

export function AvaliabilityTooltip({
  icon,
  title,
  description,
  trigger,
}: RadixAvailibilityTooltipProps) {
  return (
    <Tooltip trigger={trigger}>
      <div className="flex flex-col  text-[#252F4A] font-normal text-2sm">
        <div className="flex items-center gap-2.5 py-3 px-2.5">
          {icon}
          <span>{title}</span>
        </div>

        <span className="pb-3 px-2.5">{description}</span>
      </div>
    </Tooltip>
  );
}
